<template>
  <v-snackbar
    v-model="isTransferringEntries"
    app
    bottom
    left
    light
    color="white"
    class="downloads-list"
    elevation="24"
    :timeout="-1"
    transition="scale-transition"
    origin="center center"
  >
    <EntriesMassAssignmentLine
      v-for="request of assignmentRequests"
      :key="request.id"
      v-model="request.visible"
      :entry="request"
    />
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { subscribeToEntriesMassAssignmentChannel } from '@/channels/entries_mass_assignment_channel'

import { MASS_REASSIGNMENT_NAMESPACE } from '@/store/mass-reassignment'

import EntriesMassAssignmentLine from './EntriesMassAssignmentLine.vue'

export default {
  name: 'EntriesMassAssignmentNotifications',

  components: {
    EntriesMassAssignmentLine,
  },

  data () {
    return {
      description: '',
      progress: 0,
    }
  },

  computed: {
    isTransferringEntries () {
      return !!this.assignmentRequests.length
    },

    ...mapGetters(MASS_REASSIGNMENT_NAMESPACE, [
      'assignmentRequests',
    ]),
  },

  created () {
    subscribeToEntriesMassAssignmentChannel({ onUpdate: this.onNotificationReceived })
  },

  methods: {
    onNotificationReceived (notification) {
      this.updateAssignmentRequest(notification)
    },

    ...mapActions(MASS_REASSIGNMENT_NAMESPACE, [
      'updateAssignmentRequest',
    ]),
  },
}
</script>

<style scoped>
.downloads-list {
  .v-snack__action {
    margin: 0;
  }

  .download-entry {
    padding: 14px 0;
    border-bottom: 1px solid gray;
  }

  .download-entry:first-child {
    padding-top: 0;
  }

  .download-entry:last-child {
    padding-bottom: 0;
    border: 0;
  }
}
</style>
